import type { ReactNode } from "react";

export default function AppContainer({ children }: { children: ReactNode }) {
  return (
    <div className="configurator text-center w-full px-4 md:w-4/5 mx-auto my-5 bg-[#fcf8ef] p-4 md:p-5 rounded shadow">
      {children}
    </div>
  );
}
